import React, { useState, useEffect } from 'react'
import {
  Box,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  IconButton,
  Collapse,
  Theme,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { Modal } from '../../../components'
import { GroupN3Subdivision, N2Subdivision, Requests, User } from '../../../types/default-types'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

const InfoSubModal: React.FC<{ dataAll: any; show: boolean; onClose: () => void; className: any; img: any }> = ({
  img,
  className,
  dataAll,
  show = false,
  onClose = () => {},
}): JSX.Element => {
  const [step, setStep] = useState<number>(1)

  const [itemTerritorialId, setItemTerritorialId] = useState<number>(0)
  const [itemSubdivisionId, setItemSubdivisionId] = useState<number>(0)

  const [collapse, setCollapse] = useState<boolean>(true)

  const onBack = () => {
    setStep(step - 1)
  }

  const onCloseModal = () => {
    onClose()
    setCollapse(false)
    setTimeout(() => {
      setStep(1)
    }, 200)
  }

  useEffect(() => {
    if (!collapse) {
      setTimeout(() => setCollapse(true), 200)
    }
  }, [collapse])

  return (
    <Modal open={show} maxWidth="sm" onClose={onCloseModal} className={className.modal}>
      <IconButton
        color="primary"
        className={clsx(className.arrowBack, { [className.arrowBackDisable]: step === 1 })}
        disabled={step === 1}
        onClick={onBack}
      >
        <ArrowBackIcon style={{ color: '#818181' }} />
      </IconButton>
      <Collapse in={collapse}>
        <Box mt={1} mx={1}>
          {dataAll.type === 'my_subdivision_admin' && (
            <>
              {step === 1 && (
                <>
                  <Box className={className.job}>{dataAll.data.user.position.name}</Box>
                  <Box className={className.nameJob}>{dataAll.data.user.shortName}</Box>
                  <Box className={className.titleSub}>{dataAll.titleList}</Box>
                  <Box px={2}>
                    {dataAll.data.group.map((item: any, index: number) => {
                      return (
                        <Box
                          key={`hr-territorial${index}`}
                          className={className.itemSubModal}
                          onClick={() => {
                            setStep(step + 1)
                            setItemTerritorialId(index)
                          }}
                        >
                          <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start">
                            <Grid item>
                              <Box id="name-modal" className={className.nameSubModal}>
                                {item.user.lastName} {item.user.firstName} {item.user.middleName}
                              </Box>
                            </Grid>
                            <Grid item>
                              <img src={img.dropdown} alt="" className={className.iconSub} />
                            </Grid>
                          </Grid>
                        </Box>
                      )
                    })}
                  </Box>
                </>
              )}
              {step === 2 && (
                <>
                  <Box className={className.job}>{dataAll.data.group[itemTerritorialId].user.position.name}</Box>
                  <Box className={className.nameJob}>{dataAll.data.group[itemTerritorialId].user.shortName}</Box>
                  <Box className={className.titleSub}>Сотрудники</Box>
                  <Box px={2}>
                    {dataAll.data.group[itemTerritorialId].requests.map((item: any, index: number) => {
                      return item.command.users.map((k: User, i: number) => (
                        <Box
                          key={`hr-sub${i}`}
                          className={className.itemSubModal}
                          // onClick={() => {
                          //   setStep(step + 1)
                          //   setItemSubdivisionId(index)
                          // }}
                        >
                          <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start">
                            <Grid item>
                              <Box id="name-modal" className={className.nameSubModal}>
                                {k.lastName} {k.firstName} {k.middleName}
                              </Box>
                              <Box className={className.roleSubModal}>
                                {k.position.name.trim()}
                                {item.nomination && <>,&nbsp;«{item.nomination.name}»</>}
                                {item.command.name && (
                                  <>
                                    <br />
                                    {item.command.name}
                                  </>
                                )}
                              </Box>
                            </Grid>
                            {/* <Grid item> */}
                            {/*  <img src={img.dropdown} alt="" className={className.iconSub} /> */}
                            {/* </Grid> */}
                          </Grid>
                        </Box>
                      ))
                    })}
                  </Box>
                </>
              )}
              {step === 3 && (
                <>
                  {/* <Box className={className.job}> */}
                  {/*  {dataAll.data.territorial[itemTerritorialId].subdivision[itemSubdivisionId].title} */}
                  {/* </Box> */}
                  {/* <Box className={className.nameJob}> */}
                  {/*  {dataAll.data.territorial[itemTerritorialId].subdivision[itemSubdivisionId].name} */}
                  {/* </Box> */}
                  {/* eslint-disable-next-line max-len */}
                  {/* <Box className={className.titleSub}>{dataAll.data.territorial[itemTerritorialId].title_list}</Box> */}
                  {/* <Box px={2}> */}
                  {/*  {dataAll.data.territorial[itemTerritorialId].subdivision[itemSubdivisionId].users.map( */}
                  {/*    (item: any, index: number) => { */}
                  {/*      return ( */}
                  {/*        <Box key={`hr-users${index}`} className={className.itemSubUserModal}> */}
                  {/*          <Box className={className.nameSubUserModal}>{item.full_name}</Box> */}
                  {/*          <Box className={className.roleSubModal}> */}
                  {/*            {item?.command_name && ( */}
                  {/*              <> */}
                  {/*                {item?.command_name} */}
                  {/*                <br /> */}
                  {/*              </> */}
                  {/*            )} */}
                  {/*            {item.role.trim()} */}
                  {/*            {item.nomination && <>,&nbsp;«{item.nomination.name}»</>} */}
                  {/*          </Box> */}
                  {/*        </Box> */}
                  {/*      ) */}
                  {/*    } */}
                  {/*  )} */}
                  {/* </Box> */}
                </>
              )}
            </>
          )}

          {dataAll.type === 'my_subdivision_mm' && (
            <>
              {step === 1 && (
                <>
                  <Box className={className.job}>{dataAll.data.user.position.name}</Box>
                  <Box className={className.nameJob}>{dataAll.data.user.shortName}</Box>
                  <Box className={className.titleSub}>{dataAll.titleList}</Box>
                  <Box px={2}>
                    {dataAll.data.requests.map((item: Requests, _: number) => {
                      return item.command.users.map((k: User, i: number) => (
                        <Box
                          key={`mm-sub${i}`}
                          className={className.itemSubUserModal}
                          // onClick={() => {
                          //   setStep(step + 1)
                          //   setItemSubdivisionId(index)
                          // }}
                        >
                          <Grid container wrap="nowrap" justifyContent="flex-start" alignItems="flex-start">
                            <Grid item>
                              <Box id="name-modal" className={className.nameSubModal}>
                                {k.lastName} {k.firstName} {k.middleName}
                              </Box>
                              <Box className={className.roleSubModal}>
                                {k.position.name.trim()}
                                {item.nomination && <>,&nbsp;«{item.nomination.name}»</>}
                                {item.command.name && (
                                  <>
                                    <br />
                                    {item.command.name}
                                  </>
                                )}
                              </Box>
                            </Grid>
                            {/* <Grid item> */}
                            {/*  <img src={img.dropdown} alt="" className={className.iconSub} /> */}
                            {/* </Grid> */}
                          </Grid>
                        </Box>
                      ))
                    })}
                  </Box>
                </>
              )}
              {step === 2 && (
                <>
                  {/* <Box className={className.job}>{dataAll.data.subdivision[itemSubdivisionId].title}</Box> */}
                  {/* <Box className={className.nameJob}>{dataAll.data.subdivision[itemSubdivisionId].name}</Box> */}
                  {/* <Box className={className.titleSub}>{dataAll.data.title_list}</Box> */}
                  {/* <Box px={2}> */}
                  {/*  {dataAll.data.subdivision[itemSubdivisionId].users.map((item: any, index: number) => { */}
                  {/*    return ( */}
                  {/*      <Box key={`hr-users${index}`} className={className.itemSubUserModal}> */}
                  {/*        <Box className={className.nameSubUserModal}>{item.full_name}</Box> */}
                  {/*        <Box className={className.roleSubModal}> */}
                  {/*          {item?.command_name && ( */}
                  {/*            <> */}
                  {/*              {item?.command_name} */}
                  {/*              <br /> */}
                  {/*            </> */}
                  {/*          )} */}
                  {/*          {item.position.trim()} */}
                  {/*          {item.nomination && <>,&nbsp;«{item.nomination.name}»</>} */}
                  {/*        </Box> */}
                  {/*      </Box> */}
                  {/*    ) */}
                  {/*  })} */}
                  {/* </Box> */}
                </>
              )}
            </>
          )}

          {dataAll.type === 'my_subdivision_hr' && (
            <>
              {step === 1 && (
                <>
                  <Box className={className.job}>{dataAll.data.command.name}</Box>
                  {/* <Box className={className.nameJob}>{dataAll.data.name}</Box> */}
                  <Box className={className.titleSub}>{dataAll.title_list}</Box>
                  <Box px={2}>
                    {dataAll.data.command.users.map((item: any, index: number) => {
                      return (
                        <Box
                          key={`hr-sub${index}`}
                          // className={className.itemSubModal}
                          className={className.itemSubUserModal}
                          onClick={() => {
                            // setStep(step + 1)
                            // setItemSubdivisionId(index)
                          }}
                        >
                          <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start">
                            <Grid item>
                              <Box id="name-modal" className={className.nameSubModal}>
                                {item.lastName} {item.firstName} {item.middleName}
                              </Box>
                            </Grid>
                            {/* <Grid item> */}
                            {/*  <img src={img.dropdown} alt="" className={className.iconSub} /> */}
                            {/* </Grid> */}
                          </Grid>
                        </Box>
                      )
                    })}
                  </Box>
                </>
              )}
              {/* {step === 2 && ( */}
              {/*  <> */}
              {/*    <Box className={className.job}>{dataAll.data.subdivision[itemSubdivisionId].title}</Box> */}
              {/*    <Box className={className.nameJob}>{dataAll.data.subdivision[itemSubdivisionId].name}</Box> */}
              {/*    <Box className={className.titleSub}>{dataAll.data.title_list}</Box> */}
              {/*    <Box px={2}> */}
              {/*      {dataAll.data.subdivision[itemSubdivisionId].users.map((item: any, index: number) => { */}
              {/*        return ( */}
              {/*          <Box key={`hr-users${index}`} className={className.itemSubUserModal}> */}
              {/*            <Box className={className.nameSubUserModal}>{item.full_name}</Box> */}
              {/*            <Box className={className.roleSubModal}> */}
              {/*              {item?.command_name} */}
              {/*              {item?.command_name && <br />} */}
              {/*              {item.position.trim()} */}
              {/*              {item.nomination && <>,&nbsp;«{item.nomination.name}»</>} */}
              {/*            </Box> */}
              {/*          </Box> */}
              {/*        ) */}
              {/*      })} */}
              {/*    </Box> */}
              {/*  </> */}
              {/* )} */}
            </>
          )}

          {dataAll.type === 'my_subdivision_tt' && (
            <>
              {step === 1 && (
                <>
                  <Box className={className.job}>Ресторан</Box>
                  <Box className={className.nameJob}>{dataAll.data.subdivision.name}</Box>
                  <Box className={className.titleSub}>{dataAll.titleList}</Box>
                  <Box px={2}>
                    {dataAll.data.requests.map((item: Requests, _: number) => {
                      return item.command.users.map((k: User, i: number) => (
                        <Box key={`tt-users${i}`} className={className.itemSubUserModal}>
                          <Box className={className.nameSubUserModal}>{k.shortName}</Box>
                          <Box className={className.roleSubModal}>
                            {k.position.name.trim()}
                            {item.nomination && <>,&nbsp;«{item.nomination.name}»</>}
                            {item.command.name && (
                              <>
                                <br />
                                {item.command.name}
                              </>
                            )}
                          </Box>
                        </Box>
                      ))
                    })}
                  </Box>
                </>
              )}
            </>
          )}
        </Box>
      </Collapse>
    </Modal>
  )
}

export const MySubdivisions: React.FC<{
  img: any
  data: any
  type: string
  className: any
  expanded: boolean
  onExpand: () => void
}> = ({ type = '', data, className, img = [], expanded, onExpand = () => {} }): JSX.Element => {
  const classes = useStyles()
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const [openModal, setOpenModal] = useState<boolean>(false)
  const [dataModal, setDataModal] = useState<any>({
    data: undefined,
    title_list: undefined,
    type,
  })

  return (
    <Box className={classes.subdivisions}>
      {dataModal.data && (
        <InfoSubModal
          dataAll={dataModal}
          show={openModal}
          onClose={() => setOpenModal(false)}
          className={classes}
          img={img}
        />
      )}

      <Accordion square={false} id="subdivisions" expanded={expanded} onChange={onExpand}>
        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>Мои подразделения</AccordionSummary>
        <AccordionDetails>
          <Box className={className.contentAccordionDetails}>
            <Box mt={1} mb="14px">
              {type === 'my_subdivision_admin' && (
                <>
                  <Box className={classes.title}>{data.name}</Box>
                  {data.mms.map((item: any, index: number) => {
                    return (
                      <Box
                        key={`admin${index}`}
                        className={classes.itemSub}
                        onClick={() => {
                          setDataModal({ ...dataModal, data: item, titleList: item.name })
                          setOpenModal(true)
                        }}
                      >
                        <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start">
                          <Grid item>
                            <Box id="name" className={classes.nameSub}>
                              {item.user.lastName} {item.user.firstName} {item.user.middleName}
                            </Box>
                          </Grid>
                          <Grid item>
                            <img src={img.dropdown} alt="" className={classes.iconSub} />
                          </Grid>
                        </Grid>
                      </Box>
                    )
                  })}
                </>
              )}

              {type === 'my_subdivision_mm' && (
                <>
                  <Box className={classes.title}>{data.name}</Box>
                  {data.group.map((item: GroupN3Subdivision, index: number) => {
                    return (
                      <Box
                        key={`mm${index}`}
                        className={classes.itemSub}
                        onClick={() => {
                          setDataModal({ ...dataModal, data: item, titleList: 'Сотрудники' })
                          setOpenModal(true)
                        }}
                      >
                        <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start">
                          <Grid item>
                            <Box id="name" className={classes.nameSub}>
                              {item.user.lastName} {item.user.firstName} {item.user.middleName}
                            </Box>
                          </Grid>
                          <Grid item>
                            <img src={img.dropdown} alt="" className={classes.iconSub} />
                          </Grid>
                        </Grid>
                      </Box>
                    )
                  })}
                </>
              )}

              {type === 'my_subdivision_hr' && (
                <>
                  <Box className={classes.title}>{data.title}</Box>
                  {data.map((item: any, index: number) => {
                    return (
                      <Box
                        key={`hr${index}`}
                        className={classes.itemSub}
                        onClick={() => {
                          setDataModal({ ...dataModal, data: item, title_list: 'Сотрудники' })
                          setOpenModal(true)
                        }}
                      >
                        <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start">
                          <Grid item>
                            <Box id="name" className={classes.nameSub}>
                              {item.command.name}
                            </Box>
                          </Grid>
                          <Grid item>
                            <img src={img.dropdown} alt="" className={classes.iconSub} />
                          </Grid>
                        </Grid>
                      </Box>
                    )
                  })}
                </>
              )}

              {type === 'my_subdivision_tt' && (
                <>
                  <Box className={classes.title}>{data.title}</Box>
                  {data.map((item: N2Subdivision, index: number) => {
                    return (
                      <Box
                        key={`tt${index}`}
                        className={classes.itemSub}
                        onClick={() => {
                          setDataModal({ ...dataModal, data: item, titleList: 'Сотрудники' })
                          setOpenModal(true)
                        }}
                      >
                        <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start">
                          <Grid item>
                            <Box id="name" className={classes.nameSub}>
                              {item.subdivision.name}
                            </Box>
                          </Grid>
                          <Grid item>
                            <img src={img.dropdown} alt="" className={classes.iconSub} />
                          </Grid>
                        </Grid>
                      </Box>
                    )
                  })}
                </>
              )}

              {type === 'my_subdivision_dir' && (
                <>
                  <Box className={classes.title}>Сотрудники</Box>
                  {data.map((item: any, index: number) => {
                    return item.command.users.map((k: any, i: number) => (
                      <Box key={`dir${index}`} className={classes.itemUserSub}>
                        <Box className={classes.nameSubUserModal}>
                          {k.lastName} {k.firstName} {k.middleName}
                        </Box>
                        <Box className={classes.roleSubModal}>
                          {item?.command.name && (
                            <>
                              {item?.command.name}
                              <br />
                            </>
                          )}
                          {k.position.name.trim()}
                          {item.nomination && <>,&nbsp;«{item.nomination.name}»</>}
                        </Box>
                      </Box>
                    ))
                  })}
                </>
              )}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  subdivisions: {},
  title: {
    fontSize: 18,
    fontWeight: 600,
    transition: '0.2s',
    // marginLeft: -40,
    paddingBottom: 5,
    [down('md')]: {
      // marginLeft: '-3.8vw',
    },
    [down('sm')]: {
      // marginLeft: 0,
      fontSize: 15,
    },
  },
  itemSub: {
    marginTop: 15,
    paddingLeft: 20,
    cursor: 'pointer',
    '&:hover': {
      '& #name': {
        color: palette.text.secondary,
      },
    },
    [down('sm')]: {
      paddingLeft: 15,
      paddingRight: 5,
    },
  },
  itemUserSub: {
    marginTop: 15,
    [down('sm')]: {
      marginLeft: 15,
    },
  },
  modal: {
    '& .MuiDialog-paper': {
      paddingTop: '15px!important',
      paddingBottom: '45px!important',
    },
  },
  arrowBack: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  arrowBackDisable: {
    opacity: 0,
  },
  itemSubModal: {
    marginTop: 10,
    paddingBottom: 10,
    cursor: 'pointer',
    borderBottom: '1px solid #6C6C6C',
    '&:hover': {
      '& #name-modal': {
        color: '#6C6C6C',
      },
    },
  },
  itemSubUserModal: {
    marginTop: 10,
    paddingBottom: 10,
    borderBottom: '1px solid #6C6C6C',
  },
  job: {
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    marginBottom: 5,
    [down('sm')]: {
      fontSize: 15,
    },
  },
  nameJob: {
    fontSize: 19,
    fontWeight: 700,
    color: palette.text.secondary,
    marginBottom: 25,
    [down('sm')]: {
      fontSize: 17,
      marginBottom: 20,
    },
  },
  titleSub: {
    fontSize: 18,
    fontWeight: 600,
    paddingBottom: 10,
    [down('sm')]: {
      paddingBottom: 5,
      fontSize: 16,
    },
  },
  nameSub: {
    fontSize: 17,
    fontWeight: 700,
    transition: '0.3s',
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
  nameSubModal: {
    fontSize: 17,
    fontWeight: 600,
    transition: '0.3s',
    color: palette.text.secondary,
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
  nameSubUserModal: {
    fontSize: 17,
    fontWeight: 600,
    transition: '0.3s',
    color: palette.text.secondary,
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
  roleSubModal: {
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    marginTop: 3,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  iconSub: {
    transform: 'rotate(-90deg)',
    [down('sm')]: {
      width: 14,
    },
  },
  icon: {},
}))
